import React from 'react';

import Existing from './existing';
import Expired from './expired';
import New from './new';

import type { Grant } from '../types';

export interface Props {
  grant?: Grant;
  paths: {
    auth: string;
    destroy: string;
  };
  scopes?: string[];
}

export default function NylasGrant({ grant: grantProp, paths, scopes }: Props) {
  const [grant, setGrant] = React.useState<Grant | undefined>(grantProp);

  if (!grant) {
    return <New path={paths.auth} scopes={scopes} />;
  } else if (grant.expired) {
    return <Expired grant={grant} path={paths.auth} scopes={scopes} />;
  } else {
    return <Existing destroyPath={paths.destroy} grant={grant} onDestroy={() => setGrant(undefined)} />;
  }
}
